import { ErrorType } from "const";
import centralModals from "redux/reducers/central-modal";
import suitabilityModal from "redux/reducers/modals/suitability";

export const ModalSelector = {
  state: (state) => state.modal,
  centralModalState: (state) => ModalSelector.state(state)[centralModals.name],
  centralSubModalState: (state) => ModalSelector.centralModalState(state).subModal,
  suitabilityModalState: (state) => ModalSelector.state(state)[suitabilityModal.name],
  currentCode: (state) => ModalSelector.centralModalState(state).code,
  isSystemClosePopupActive: (state) => ModalSelector.currentCode(state) === ErrorType.SystemClose,
};
